import { render, staticRenderFns } from "./Meeting.vue?vue&type=template&id=8804b946&"
import script from "./Meeting.vue?vue&type=script&lang=js&"
export * from "./Meeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/ojg15/Desktop/Programming/me-cfs-group-canterbury/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
installComponents(component, {VImg})
